// extracted by mini-css-extract-plugin
export default {"caroselBoxShado":"Round_caroselBoxShado__B-uCM","slider":"Round_slider__iJYYb","slidertrack":"Round_slidertrack__TyMW+","scroll":"Round_scroll__sh1gd","slide":"Round_slide__AiZL3"};